module.exports = __webpack_public_path__ + "img/instyle-mens-fragrances.aaaa1f71.png";